module.exports = __webpack_public_path__ + "static/media/landingpage-freelancer-2.4f6c0efc.webp";